"use client";

import { useEffect, useState } from "react";

/* True when the viewport is at-or-below the mobile breakpoint OR the user
 * has OS-level reduced-motion turned on. Animation components branch on
 * this to skip GSAP / framer / three.js work on phones — CSS animations
 * are killed by the matching media query in globals.css.
 *
 * SSR-safe: initializes as false (desktop default) on both server and
 * first client render. A passive effect syncs the real matchMedia value
 * without triggering a hydration mismatch. The one-frame desktop default
 * on mobile is imperceptible because CSS already disables animations on
 * mobile (so there is no flash of animated content). */
const MOBILE_QUERY = "(max-width: 768px), (prefers-reduced-motion: reduce)";

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    setIsMobile(mq.matches);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  return isMobile;
}
